import {useConstant, useForceUpdate} from '@sail/engine';
import {useEffect} from 'react';
import {useParentViewportSnapshot} from '../ParentViewportProvider';

const MOBILE_BREAKPOINT_MAX_WIDTH = 600;

export default function useCurrentBreakpoints() {
  const queries = useConstant(() => {
    return {
      mobile: window.matchMedia(
        `(max-width: ${MOBILE_BREAKPOINT_MAX_WIDTH}px)`,
      ),
      tablet: window.matchMedia('(min-width: 601px) and (max-width: 1024px)'),
      desktop: window.matchMedia('(min-width: 1025px) and (max-width: 1450px)'),
      widescreen: window.matchMedia('(min-width: 1451px)'),
    };
  });

  const forceUpdate = useForceUpdate();

  useEffect(() => {
    const values = Object.values(queries);
    values.forEach((mq) => mq.addEventListener('change', forceUpdate));
    return () =>
      values.forEach((mq) => mq.removeEventListener('change', forceUpdate));
  }, [forceUpdate, queries]);

  return Object.entries(queries)
    .filter((entry) => entry[1].matches)
    .map(([key]) => key);
}

export function useIsMobileBreakpoints() {
  const currentBreakpoints = useCurrentBreakpoints();
  return currentBreakpoints.includes('mobile');
}

export function useEffectiveMobileBreakpoints() {
  const parentViewportSnapshot = useParentViewportSnapshot();
  const isIframeMobile = useIsMobileBreakpoints();

  // The current window may be an embedded widget whose media query reflects
  // only the widget dimensions. Prefer the parent visual viewport when the
  // host sends one. Without a parent snapshot, the current-window breakpoint
  // remains the fallback for standalone, hostless, and older integrations.
  return parentViewportSnapshot
    ? parentViewportSnapshot.width <= MOBILE_BREAKPOINT_MAX_WIDTH
    : isIframeMobile;
}
